import { ExploreActionTypes, ChatMessage } from './exploreTypes';

export const exploreApiResponseSuccess = (actionType: string, data: any) => ({
  type: ExploreActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const exploreApiResponseError = (actionType: string, error: string) => ({
  type: ExploreActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const sendExploreMessage = (message: string, history: ChatMessage[], sessionId: string | null) => ({
  type: ExploreActionTypes.SEND_MESSAGE,
  payload: { message, history, sessionId },
});

export const summariseExplore = (sessionId: string, insightText: string, history: ChatMessage[]) => ({
  type: ExploreActionTypes.SUMMARISE,
  payload: { sessionId, insightText, history },
});

export const resetExplore = () => ({
  type: ExploreActionTypes.RESET,
});
